import React, { useEffect, useState } from 'react';
import css from './index.module.scss';
import Chip from '@components/base/chip';
import { useNavigate } from 'react-router-dom';
import ProductDocumentTab from './components/product-document-tab/documents-tab';
import SupplierDocumentsTab from './components/supplier-document-tab';
import { ProductIndividualStates } from '../..';
import { ProductInfo } from '@helpers/types/product';

interface IDocumentTabState {
  activeStep: number;
}

const getInitialActiveStep = () => {
  const searchParams = new URLSearchParams(location.search);
  const activeSubTab = searchParams.get('activeSubTab');
  if (!activeSubTab) return 1;
  if (activeSubTab === 'product') return 1;
  if (activeSubTab === 'supplier') return 2;

  return 1;
};

interface IDocumentsTabProps {
  productState: ProductIndividualStates;
  onChange: (param: ProductInfo) => void;
}

const DocumentsTab = (props: IDocumentsTabProps) => {
  const { productState, onChange } = props;
  const { productInfo } = productState;
  const navigate = useNavigate();
  const [documentTabState, setDocumentTabState] = useState<IDocumentTabState>({
    activeStep: getInitialActiveStep()
  });

  const { activeStep } = documentTabState;

  const changeTab = (step: number) => {
    setDocumentTabState((prevState: IDocumentTabState) => ({ ...prevState, activeStep: step }));

    const searchParams = new URLSearchParams(location.search);

    if (step === 1) {
      searchParams.set('activeSubTab', 'product');
    } else if (step === 2) {
      searchParams.set('activeSubTab', 'supplier');
    }

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
      },
      { replace: true }
    );
  };

  return (
    <div className={css.mainWrapper}>
      <div className={css.taskChipWrapper}>
        <Chip
          label="Product"
          variant={activeStep == 1 ? `filled` : `outlined`}
          onClick={() => changeTab(1)}
        />
        <Chip
          label="Supplier"
          variant={activeStep == 2 ? `filled` : `outlined`}
          onClick={() => changeTab(2)}
        />
      </div>
      {activeStep === 1 && <ProductDocumentTab productInfo={productInfo} onChange={onChange} />}
      {activeStep === 2 && <SupplierDocumentsTab productState={productState} />}
    </div>
  );
};

export default DocumentsTab;
